import api from './api';

/**
 * Fetch all states (usually filtered by country, defaults to Nigeria)
 * @param {Object} params - Query parameters
 * @returns {Promise<Object>} Response data
 */
export const getStates = async (params = {}) => {
  const response = await api.get('/admin/states/', { params });
  return response.data;
};

/**
 * Fetch LGAs for a specific state
 * @param {number|string} stateId - The ID of the state
 * @returns {Promise<Object>} Response data
 */
export const getLGAs = async (stateId) => {
  const response = await api.get('/admin/lgas/', { 
    params: { state_id: stateId } 
  });
  return response.data;
};

/**
 * Fetch Cities for a specific LGA
 * @param {number|string} lgaId - The ID of the LGA
 * @returns {Promise<Object>} Response data
 */
export const getCitiesByLGA = async (lgaId) => {
  const response = await api.get('/admin/cities-by-lga/', { 
    params: { lga_id: lgaId } 
  });
  return response.data;
};

/**
 * Fetch Cities for a specific State (Legacy/Fallback)
 * @param {number|string} stateId - The ID of the state
 * @returns {Promise<Object>} Response data
 */
export const getCitiesByState = async (stateId) => {
  const response = await api.get('/admin/cities/', { 
    params: { state_id: stateId } 
  });
  return response.data;
};
